"use client";

import { useEffect } from "react";

// Stops the trackpad's two-finger swipe from navigating the browser back while the editor is open. The piano roll's own wheel handlers already call preventDefault, but they only cover the Konva stage — a swipe that starts over the toolbar, the backing-track lane, the mixer or the hint bar never reaches them, and the browser takes the gesture as history navigation. overscroll-behavior is only honoured on the ROOT scroller, so it has to go on documentElement rather than on the editor's own wrapper, and it is set here rather than in global.css so it applies on this route alone and the rest of the app keeps its normal overscroll.
export function LockHorizontalOverscroll() {
  useEffect(() => {
    const rootElement = document.documentElement;
    const previousOverscrollBehaviorX = rootElement.style.overscrollBehaviorX;
    rootElement.style.overscrollBehaviorX = "none";

    return () => {
      rootElement.style.overscrollBehaviorX = previousOverscrollBehaviorX;
    };
  }, []);

  return null;
}
